<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.25 14.25H1.95C1.52996 14.25 1.31994 14.25 1.15951 14.1683C1.01839 14.0964 0.90365 13.9816 0.831745 13.8405C0.75 13.6801 0.75 13.47 0.75 13.05V0.75M14.25 3.75L10.1743 7.82574C10.0258 7.97424 9.9515 8.0485 9.86588 8.07632C9.79057 8.10079 9.70943 8.10079 9.63412 8.07632C9.5485 8.0485 9.47424 7.97424 9.32574 7.82574L7.92426 6.42426C7.77576 6.27576 7.7015 6.2015 7.61588 6.17368C7.54057 6.14921 7.45943 6.14921 7.38412 6.17368C7.2985 6.2015 7.22424 6.27576 7.07574 6.42426L3.75 9.75M14.25 3.75H11.25M14.25 3.75V6.75"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
